<template>
  <div class="main">
    <headerBar current="knowus"></headerBar>
    <div class="banner">
      <div>
        <h3>北京联运管家供应链管理有限公司</h3>
        <h4>北京联运管家供应链管理有限公司成立于2019年，是国家铁<br />路集团下属企业与普洛斯隐山现代物流产业基金共同组建的一<br />家混合所有制企业</h4>
      </div>
    </div>
    <div class="growup">
      <h3>成长历程</h3>
      <div class="pc">
        <div class="course">
          <img src="../assets/pc/growup-ad.png" />
        </div>
        <div class="list">
          <div>
            <img src="../assets/pc/icon-vision.png" />
            <h4>企业愿景</h4>
            <p>成为最具有价值的涉铁供应链管理服务公司</p>
          </div>
          <div>
            <img src="../assets/pc/icon-value.png" />
            <h4>价值观</h4>
            <p>客户第一、服务创造价值。为客户解决问题、为股东带来回报、让合作伙伴受益、让员工幸福成长。</p>
          </div>
          <div>
            <img src="../assets/pc/icon-mission.png" />
            <h4>企业使命</h4>
            <p>聚焦涉铁物流产业生态发展，提供IT技术为核心的供应链管理综合解决方案服务，让物流更简单、更高效</p>
          </div>
        </div>
      </div>
      <div class="mobile">
        <div class="course">
          <img src="../assets/mobile/growup-ad.png" />
        </div>
        <div class="swiper">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="../assets/pc/icon-vision.png" />
                <h4>企业愿景</h4>
                <p>成为最具有价值的涉铁供应链管理服务公司</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/pc/icon-value.png" />
                <h4>价值观</h4>
                <p>客户第一、服务创造价值。为客户解决问题、为股东带来回报、让合作伙伴受益、让员工幸福成长。</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/pc/icon-mission.png" />
                <h4>企业使命</h4>
                <p>聚焦涉铁物流产业生态发展，提供IT技术为核心的供应链管理综合解决方案服务，让物流更简单、更高效</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="seniority">
      <h3>持续的科技研发投入</h3>
      <div class="pc">
        <img src="../assets//picc5.png" />
      </div>
      <div class="mobile">
        <div class="swiper">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="../assets/mobile/picc1.png" />
              </div>
              <div class="swiper-slide">
                <img src="../assets/mobile/picc2.png" />
              </div>
              <div class="swiper-slide">
                <img src="../assets/mobile/picc3.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <p>联运管家旨在通过科技创新，赋能国内各类环铁路物流企业的数字化运营能力，实现我国大宗物流和供应链产业经营效率的整体提升</p>
    </div>
    <div class="staff">
      <h3>员工风采</h3>
      <div class="pc">
        <ul>
          <li>
            <img src="../assets//picc6.png" />
            <p>铁路场站现场调研,实地了解运输组织流程，升级信息化服务</p>
          </li>
          <li>
            <img src="../assets//picc7.png" />
            <p>我们在一起，就会了不起。拥抱梦想，展翅翱翔，终有一天我们会散发光芒。</p>
            <span>2023新年庆典</span>
          </li>
          <li>
            <img src="../assets//picc8.png" />
            <p>和谐创新，开拓市场，凝聚力量，共创辉煌。</p>
            <span>考察集装箱港口</span>
          </li>
        </ul>
      </div>
      <div class="mobile">
        <div class="swiper">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="../assets//picc6.png" />
                <p>铁路场站现场调研,实地了解运输组织流程，升级信息化服务</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets//picc7.png" />
                <p>我们在一起，就会了不起。拥抱梦想，展翅翱翔，终有一天我们会散发光芒。</p>
                <span>2023新年庆典</span>
              </div>
              <div class="swiper-slide">
                <img src="../assets//picc8.png" />
                <p>和谐创新，开拓市场，凝聚力量，共创辉煌。口</p>
                <span>考察集装箱港口</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="partner">
      <h3>合作伙伴</h3>
      <div class="pc">
        <div class="roll">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="../assets/pc/partner1.png" style="width: 1.83rem" />
              </div>
              <div class="swiper-slide">
                <img src="../assets/pc/partner2.png" style="width: 2.6rem" />
              </div>
              <div class="swiper-slide">
                <img src="../assets/pc/partner3.png" style="width: 2.8rem" />
              </div>
              <div class="swiper-slide">
                <img src="../assets/pc/partner4.png" style="width: 1.54rem" />
              </div>
              <div class="swiper-slide">
                <img src="../assets/pc/partner5.png" style="width: 1.88rem" />
              </div>
              <div class="swiper-slide">
                <img src="../assets/pc/partner6.png" style="width: 2.8rem" />
              </div>
              <div class="swiper-slide">
                <img src="../assets/pc/partner7.png" style="width: 2.6rem" />
              </div>
              <div class="swiper-slide">
                <img src="../assets/pc/partner8.png" style="width: 1rem" />
              </div>
            </div>
          </div>
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
      </div>
      <div class="mobile">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img src="../assets/mobile/partner1.png" />
            </div>
            <div class="swiper-slide">
              <img src="../assets/mobile/partner2.png" />
            </div>
            <div class="swiper-slide">
              <img src="../assets/mobile/partner3.png" />
            </div>
            <div class="swiper-slide">
              <img src="../assets/mobile/partner4.png" />
            </div>
            <div class="swiper-slide">
              <img src="../assets/mobile/partner5.png" />
            </div>
            <div class="swiper-slide">
              <img src="../assets/mobile/partner6.png" />
            </div>
            <div class="swiper-slide">
              <img src="../assets/mobile/partner7.png" />
            </div>
            <div class="swiper-slide">
              <img src="../assets/mobile/partner8.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <footerBar></footerBar>
  </div>
</template>

<script>
import headerBar from "../components/headerBar"
import footerBar from "../components/footerBar"
import Swiper from "swiper"
import "swiper/dist/css/swiper.css"
export default {
  name: "knowus",
  components: { headerBar, footerBar, },
  mounted() {
    new Swiper(".partner .pc .roll .swiper-container", {
      slidesPerView: 4,
      speed: 500,
      loop: true,
      autoplay: {
        delay: 1500,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    })
    new Swiper(".growup .mobile .swiper .swiper-container", {
      slidesPerView: 1.5,
      spaceBetween: 10,
      speed: 500,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    })
    new Swiper(".seniority .mobile .swiper .swiper-container", {
      slidesPerView: 1.5,
      spaceBetween: 10,
      speed: 500,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    })
    new Swiper(".staff .mobile .swiper .swiper-container", {
      slidesPerView: 1.5,
      spaceBetween: 10,
      speed: 500,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    })
    new Swiper(".partner .mobile .swiper-container", {
      slidesPerView: 5,
      speed: 500,
      loop: true,
      autoplay: {
        delay: 1500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    })
  },
};
</script>

<style scoped>
@media screen and (min-width: 1025px) {
  .mobile {
    display: none;
  }

  .banner {
    background: url("../assets/pc/banner1.png") no-repeat center;
    background-size: 100%;
    margin-top: 0.7rem;
  }

  .banner div {
    height: 4.65rem;
    width: 13rem;
    margin: 0 auto;
    padding-top: 0.9rem;
  }

  .banner div h3 {
    font-size: 0.48rem;
    color: #fff;
    font-weight: bold;
  }

  .banner div h4 {
    color: #fff;
    font-size: 0.16rem;
    line-height: 0.28rem;
    padding: 0.4rem 0 0.6rem;
  }

  .growup {
    margin-top: 1.64rem;
    background: url("../assets/pc/growup-bg.png") no-repeat top center;
    background-size: 100%;
  }

  .growup h3 {
    text-align: center;
    font-size: 0.48rem;
    color: #091c2e;
    font-weight: bold;
  }

  .growup .course {
    margin-top: 0.74rem;
  }

  .growup .course img {
    width: 12.87rem;
    display: block;
    margin: 0 auto;
  }

  .growup .list {
    width: 13rem;
    display: flex;
    align-items: center;
    margin: 1.52rem auto 0;
  }

  .growup .list div {
    width: 4.1rem;
    height: 2.66rem;
    background: #fff;
    box-shadow: 0px 0px 0.24rem 0px rgba(153, 153, 153, 0.17);
    margin: 0 0.1rem;
    padding-top: 0.34rem;
  }

  .growup .list div img {
    margin: 0 auto;
    display: block;
    height: 0.52rem;
  }

  .growup .list div h4 {
    font-size: 0.22rem;
    color: #091c2e;
    font-weight: bold;
    margin-top: 0.42rem;
    text-align: center;
  }

  .growup .list div p {
    font-size: 0.16rem;
    color: #091c2e;
    margin-top: 0.16rem;
    padding: 0 0.44rem;
  }

  .seniority {
    margin-top: 1.6rem;
    height: 7.8rem;
    background: #f5f7f9;
    padding-top: 1.6rem;
  }

  .seniority h3 {
    text-align: center;
    font-size: 0.48rem;
    color: #091c2e;
    font-weight: bold;
  }

  .seniority img {
    display: block;
    margin: 0.8rem auto 0.44rem;
    width: 12.8rem;
  }

  .seniority p {
    text-align: center;
    font-size: 0.18rem;
    color: #091c2e;
  }

  .staff {
    padding-top: 1.6rem;
  }

  .staff h3 {
    text-align: center;
    font-size: 0.48rem;
    color: #091c2e;
    font-weight: bold;
  }

  .staff ul {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.78rem;
  }

  .staff ul li {
    width: 4.14rem;
    height: 4.4rem;
    background: #ffffff;
    border: 1px solid #d2d2d2;
    margin: 0 0.1rem;
  }

  .staff ul li img {
    width: 100%;
    display: block;
  }

  .staff ul li p {
    font-size: 0.18rem;
    color: #091c2e;
    padding: 0.3rem 0.4rem 0;
  }

  .staff ul li span {
    display: block;
    text-align: right;
    font-size: 0.18rem;
    color: #091c2e;
    padding: 0.1rem 0.4rem 0;
  }

  .partner {
    margin-top: 1.6rem;
    height: 3.6rem;
  }

  .partner h3 {
    text-align: center;
    font-size: 0.48rem;
    color: #091c2e;
    font-weight: bold;
  }

  .partner .roll {
    width: 13rem;
    padding: 0 0.6rem;
    margin: 0 auto;
    margin-top: 0.6rem;
    position: relative;
  }

  .partner .roll .swiper-slide {
    height: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

@media screen and (max-width: 1024px) {
  .pc {
    display: none;
  }

  .main {
    background: url("../assets/mobile/page-bg.png") no-repeat left 24rem;
    background-size: 7.19rem;
  }

  .banner {
    background: url("../assets/mobile/banner1.png") no-repeat center;
    background-size: cover;
    margin-top: 1rem;
  }

  .banner div {
    height: 4.81rem;
    padding: 3.2rem 0.2rem 0;
    position: relative;
  }

  .banner div h3 {
    font-size: 0.42rem;
    color: #fff;
    font-weight: bold;
    font-family: LiShu;
  }

  .banner div h4 {
    color: #fff;
    font-size: 0.23rem;
    margin-top: 0.1rem;
    font-family: SongTi;
  }

  .growup {
    margin-top: 0.7rem;
    background: url("../assets/mobile/circular-bg.png") no-repeat left top,
      url("../assets/mobile/service-bg.png") no-repeat right 1rem;
    background-size: 2.6rem, 3.88rem;
  }

  .growup h3 {
    text-align: center;
    font-size: 0.32rem;
    color: #091c2e;
    font-weight: bold;
  }

  .growup .course {
    margin-top: 0.5rem;
  }

  .growup .course img {
    width: 6.84rem;
    display: block;
    margin: 0 auto;
  }

  .growup .swiper {
    margin-top: 0.5rem;
    padding: 0 0.2rem;
  }

  .growup .swiper .swiper-slide {
    border: 2px solid rgb(234, 235, 255);
    border-radius: 0.2rem;
    padding: 0.3rem 0.18rem 0;
    height: 3.4rem;
  }

  .growup .swiper .swiper-slide img {
    display: block;
    height: 0.7rem;
    margin: 0 auto;
  }

  .growup .swiper .swiper-slide h4 {
    font-size: 0.3rem;
    margin-top: 0.3rem;
    color: #060606;
    font-weight: bold;
    text-align: center;
  }

  .growup .swiper .swiper-slide p {
    font-size: 0.28rem;
    color: #595959;
    margin-top: 0.2rem;
    line-height: 0.38rem;
    font-family: KaiTi;
  }

  .seniority h3 {
    line-height: 1.8rem;
    text-align: center;
    font-size: 0.32rem;
    color: #091c2e;
    font-weight: bold;
  }

  .seniority .swiper {
    padding: 0 0.2rem;
  }

  .seniority .swiper img {
    display: block;
  }

  .seniority p {
    padding: 0 0.24rem;
    font-size: 0.28rem;
    color: #595959;
    text-indent: 2em;
    margin-top: 0.4rem;
    line-height: 0.4rem;
    font-family: KaiTi;
  }

  .staff h3 {
    line-height: 1.8rem;
    text-align: center;
    font-size: 0.32rem;
    color: #091c2e;
    font-weight: bold;
  }

  .staff ul {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.78rem;
  }

  .staff ul li {
    width: 4.14rem;
    height: 4.4rem;
    background: #ffffff;
    border: 1px solid #d2d2d2;
    margin: 0 0.1rem;
  }

  .staff ul li img {
    width: 100%;
    display: block;
  }

  .staff ul li p {
    font-size: 0.18rem;
    color: #091c2e;
    padding: 0.3rem 0.4rem 0;
  }

  .staff .swiper {
    padding: 0 0.2rem;
  }

  .staff .swiper .swiper-slide {
    border: 2px solid rgb(234, 235, 255);
    border-radius: 0.2rem;
    height: 5.5rem;
    padding: 0.2rem;
    background: rgba(255, 255, 255, 0.4);
  }

  .staff .swiper .swiper-slide img {
    display: block;
    width: 100%;
  }

  .staff .swiper .swiper-slide p {
    font-size: 0.3rem;
    color: #595959;
    height: 1.6rem;
    line-height: 0.4rem;
    padding-top: 0.4rem;
    font-family: KaiTi;
  }

  .staff .swiper .swiper-slide span {
    display: block;
    font-size: 0.26rem;
    font-family: KaiTi;
    text-align: right;
  }

  .partner {
    padding: 0 0.3rem 0.7rem;
  }

  .partner h3 {
    line-height: 1.8rem;
    text-align: center;
    font-size: 0.32rem;
    color: #091c2e;
    font-weight: bold;
  }

  .partner .swiper-slide {
    height: 0.7rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .partner .swiper-slide img {
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/knowus.vue